// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3RWAo","bigColWidth":"Table_bigColWidth__1GeEu","biggerColWidth":"Table_biggerColWidth__3BPT9","row":"Table_row__3pqiH","col":"Table_col__36JRq"};